<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.mails.historique.list.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.mails.historique.list.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="4">
          <search-by
            :datasource="dsHistorique"
            attr="nom"
            i18n="administration.mails.historique.list.search.nom"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <search-by
            :datasource="dsHistorique"
            attr="prenom"
            i18n="administration.mails.historique.list.search.prenom"
          />
        </v-col>
      </v-row>
      <datasource-table :datasource="dsHistorique">
        <template #item.nom="{item}">
          {{ item.nom }}
        </template>
        <template #item.prenom="{item}">
          {{ item.prenom }}
        </template>
        <template #item.etat="{item}">
          {{ item.libelle }}
        </template>
        <template #item.email="{item}">
          {{ item.email }}
        </template>
        <template #item.dateCreation="{item}">
          {{ formatDate(item.dateCreation) }}
        </template>
        <template #item.dateEnvoi="{item}">
          {{ item.dateEnvoi ? formatDate(item.dateEnvoi) : '' }}
        </template>
        <template #item.actions="{item}">
          <v-btn
            v-if="boutonRenvoiVisible(item)"
            small
            icon
            @click.stop="send(item)"
          >
            <v-icon>mdi-email</v-icon></v-btn
          >
        </template>
      </datasource-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  mounted() {
    this.dsHistorique.refresh();
  },
  props: {
    /** Titre de la page */
    title: {
      type: String,
      default: null,
    },
    /** Les infos pour le retour vers le menu paramétrage */
    returnRoute: {},
  },
  data() {
    const dsHistorique = new Datasource('administration/historiqueMail', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['etat'],
      descending: false,
      labelNamespace: 'administration.mails.historique.list.table',
      args: {},
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenom',
          sortable: true,
        },
        {
          value: 'email',
          sortable: true,
        },
        {
          value: 'dateCreation',
          sortable: true,
        },
        {
          value: 'dateEnvoi',
          sortable: true,
        },
        {
          value: 'etat',
          sortable: true,
        },
        {
          value: 'actions',
          sortable: false,
        },
      ],
    });

    return {
      dsHistorique,
    };
  },
  methods: {
    send(item) {
      this.$api('administration/historiqueMail/renvoiMail/' + item.id)
        .post()
        .then(() => {
          this.dsHistorique.debouncedRefresh();
        });
    },
    boutonRenvoiVisible(item) {
      if (item.etat == 'EN_ATTENTE') {
        const date1 = new Date(item.dateCreation);
        date1.setHours(date1.getHours() + 2);
        const d2 = new Date();
        if (date1 < d2) {
          return true;
        } else if (date1 > d2) {
          return false;
        }
      }

      return false;
    },
    formatDate(item) {
      const date = new Date(item);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });
    },
  },
};
</script>
